var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge",class:_vm.analysisStatus},[_vm._v(" "+_vm._s(_vm.$t(("analysisStatuses." + _vm.analysisStatus)).toUpperCase())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }